(function () {
  var STORAGE_KEY = "navajiva-distributor-onboarding";
  var TOTAL_STEPS = 4;
  var MAX_UPLOAD_BYTES = 6 * 1024 * 1024;
  var LOCKED_STATUSES = ["submitted", "under_review", "call_pending", "agreement_pending", "agreement_signed", "approved"];

  function init() {
    var pages = document.querySelectorAll(".njv-onboarding-page");
    if (!pages.length) {
      return;
    }

    pages.forEach(function (page) {
      var configScript = page.querySelector(".njv-onboarding-config");
      var mountNode = page.querySelector("[data-onboarding-app]");
      if (!configScript || !mountNode) {
        return;
      }

      var config = parseJson(configScript.textContent || "{}");
      var context = {
        page: page,
        mountNode: mountNode,
        config: config,
        state: createState(config),
      };

      bindStaticActions(context);
      restoreSession(context);
      render(context);
      rehydrate(context);
    });
  }

  function parseJson(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      console.error("Unable to parse distributor onboarding config.", error);
      return {};
    }
  }

  function createState(config) {
    return {
      step: 1,
      mobile: "",
      otpSessionId: "",
      otp: "",
      token: "",
      loading: "",
      error: "",
      message: "",
      currentApplication: null,
      form: createEmptyForm(),
      tracking: buildTrackingPayload(config),
    };
  }

  function createEmptyForm() {
    return {
      otpVerified: false,
      fullName: "",
      mobile: "",
      email: "",
      businessName: "",
      gstin: "",
      drugLicenseNumber: "",
      businessAddress: "",
      city: "",
      state: "",
      pincode: "",
      serviceArea: "",
      documents: {
        gst_certificate: null,
        drug_license: null,
      },
    };
  }

  function buildTrackingPayload(config) {
    var url = new URL(window.location.href);
    var params = url.searchParams;
    return {
      channel: "shopify_website",
      landingPage: config.pagePath || window.location.pathname,
      referrer: document.referrer || "",
      utmSource: params.get("utm_source") || "",
      utmMedium: params.get("utm_medium") || "",
      utmCampaign: params.get("utm_campaign") || "",
      utmContent: params.get("utm_content") || "",
      utmTerm: params.get("utm_term") || "",
      gclid: params.get("gclid") || "",
      fbclid: params.get("fbclid") || "",
    };
  }

  function restoreSession(context) {
    var raw = safeStorageGet(STORAGE_KEY);
    if (!raw) {
      return;
    }

    var saved = parseJson(raw);
    if (!saved || typeof saved !== "object") {
      return;
    }

    context.state.mobile = saved.mobile || "";
    context.state.token = saved.token || "";
    context.state.form.mobile = saved.mobile || "";
    context.state.currentApplication = saved.currentApplication || null;
    if (saved.currentApplication) {
      hydrateFormFromApplication(context, saved.currentApplication);
      context.state.step = resolveStepForApplication(saved.currentApplication);
    }
  }

  function persistSession(context) {
    safeStorageSet(
      STORAGE_KEY,
      JSON.stringify({
        mobile: context.state.mobile,
        token: context.state.token,
        currentApplication: context.state.currentApplication,
      }),
    );
  }

  function clearSession() {
    safeStorageRemove(STORAGE_KEY);
  }

  function safeStorageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeStorageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      console.warn("Unable to persist distributor onboarding session.", error);
    }
  }

  function safeStorageRemove(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.warn("Unable to clear distributor onboarding session.", error);
    }
  }

  function bindStaticActions(context) {
    context.page.querySelectorAll("[data-scroll-to-form]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        context.mountNode.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  async function rehydrate(context) {
    if (!context.state.token) {
      return;
    }

    try {
      var application = await apiRequest(context.config.apiBaseUrl, "/applications/me", {
        method: "GET",
        token: context.state.token,
      });

      if (application) {
        context.state.currentApplication = application;
        hydrateFormFromApplication(context, application);
        context.state.message = buildStatusMessage(application.status);
        context.state.step = resolveStepForApplication(application);
        persistSession(context);
        render(context);
      }
    } catch (error) {
      console.warn("Unable to rehydrate website onboarding session.", error);
    }
  }

  function hydrateFormFromApplication(context, application) {
    var form = context.state.form;
    form.otpVerified = true;
    form.fullName = application.fullName || "";
    form.mobile = application.mobile || context.state.mobile || "";
    form.email = application.email || "";
    form.businessName = application.businessName || "";
    form.gstin = application.gstin || "";
    form.drugLicenseNumber = application.drugLicenseNumber || "";
    form.businessAddress = application.businessAddress || "";
    form.city = application.city || "";
    form.state = application.state || "";
    form.pincode = application.pincode || "";
    form.serviceArea = application.serviceArea || "";
    form.documents = {
      gst_certificate: findApplicationDocument(application, "gst_certificate"),
      drug_license: findApplicationDocument(application, "drug_license"),
    };
    context.state.mobile = form.mobile;
  }

  function findApplicationDocument(application, type) {
    var documents = Array.isArray(application.documents) ? application.documents : [];
    return documents.find(function (document) {
      return document.type === type;
    }) || null;
  }

  function resolveStepForApplication(application) {
    if (!application) {
      return 1;
    }

    if (LOCKED_STATUSES.indexOf(application.status) !== -1) {
      return 4;
    }

    return application.documents && application.documents.length ? 3 : 2;
  }

  function render(context) {
    var state = context.state;
    var isLocked = hasLockedStatus(state.currentApplication);
    var supportPhone = escapeHtml(context.config.supportPhone || "");
    var supportEmail = escapeHtml(context.config.supportEmail || "");
    var statusLabel = state.currentApplication ? formatStatus(state.currentApplication.status) : "Not started";
    var statusMessage = state.message || (state.currentApplication ? buildStatusMessage(state.currentApplication.status) : "");

    context.mountNode.innerHTML = [
      '<div class="njv-form-shell">',
      '  <div class="njv-form-toolbar">',
      '    <div>',
      '      <p class="njv-eyebrow">Distributor onboarding</p>',
      '      <h2>Complete your distributor application online</h2>',
      '    </div>',
      '    <span class="njv-pill">' + escapeHtml(statusLabel) + '</span>',
      "  </div>",
      statusMessage
        ? '  <div class="njv-status-panel"><strong>Application status</strong><p>' + escapeHtml(statusMessage) + "</p></div>"
        : "",
      state.error ? '  <div class="njv-alert">' + escapeHtml(state.error) + "</div>" : "",
      state.message && !statusMessage ? '  <div class="njv-inline-note">' + escapeHtml(state.message) + "</div>" : "",
      renderProgress(state.step),
      renderStepOne(context),
      renderStepTwo(context, isLocked),
      renderStepThree(context, isLocked),
      renderStepFour(context, isLocked),
      '  <div class="njv-form-actions">',
      state.token
        ? '    <button type="button" class="njv-btn njv-btn-link" data-action="reset-session">Use another mobile number</button>'
        : "",
      supportPhone || supportEmail
        ? '    <div class="njv-helper">Need help? ' +
            (supportPhone ? "Call " + supportPhone : "") +
            (supportPhone && supportEmail ? " · " : "") +
            (supportEmail ? "Email " + supportEmail : "") +
          "</div>"
        : "",
      "  </div>",
      "</div>",
    ].join("");

    bindDynamicActions(context);
  }

  function renderProgress(step) {
    var labels = ["Verify mobile", "Business details", "Documents", "Review & submit"];
    return [
      '<div class="njv-form-progress">',
      labels
        .map(function (label, index) {
          var stepNumber = index + 1;
          var className = step === stepNumber ? "is-active" : step > stepNumber ? "is-complete" : "";
          return (
            '<div class="njv-progress-step ' +
            className +
            '">' +
            '<span class="njv-step-badge" data-step="' +
            stepNumber +
            '"></span><span>' +
            escapeHtml(label) +
            "</span></div>"
          );
        })
        .join(""),
      "</div>",
    ].join("");
  }

  function renderStepOne(context) {
    var state = context.state;
    var disabled = state.loading === "requestOtp" || state.loading === "verifyOtp" ? "disabled" : "";
    var verified = state.form.otpVerified && state.token;
    var otpRequested = Boolean(state.otpSessionId);
    return [
      '<section class="njv-form-step ' + (state.step === 1 ? "is-active" : "") + '">',
      "  <h3>Step 1 · Verify mobile number</h3>",
      '  <p class="njv-helper">Verify your mobile number to start the distributor application. We will send a one-time password to continue.</p>',
      '  <div class="njv-form-grid">',
      renderInputField("Mobile number", "mobile", state.mobile, {
        type: "tel",
        placeholder: "Enter 10-digit mobile number",
        inputmode: "numeric",
        autocomplete: "tel",
        disabled: verified,
      }),
      verified
        ? '<div class="njv-form-meta"><strong>Mobile verified</strong><p>' +
          escapeHtml(state.mobile) +
          " is ready for onboarding.</p></div>"
        : otpRequested
          ? renderInputField("OTP", "otp", state.otp, {
            type: "text",
            placeholder: "Enter OTP",
            inputmode: "numeric",
            autocomplete: "one-time-code",
            })
          : '<div class="njv-form-meta"><strong>Request OTP first</strong><p>Enter your mobile number and request OTP to receive the verification code.</p></div>',
      "  </div>",
      '  <div class="njv-form-actions">',
      verified
        ? '    <button type="button" class="njv-btn njv-btn-primary" data-action="go-next">Continue to business details</button>'
        : '    <button type="button" class="njv-btn njv-btn-secondary" data-action="request-otp" ' +
          disabled +
          ">" +
          (state.loading === "requestOtp" ? "Sending OTP..." : otpRequested ? "Resend OTP" : "Request OTP") +
          "</button>" +
          (otpRequested
            ? '    <button type="button" class="njv-btn njv-btn-primary" data-action="verify-otp" ' +
              disabled +
              ">" +
              (state.loading === "verifyOtp" ? "Verifying..." : "Verify OTP") +
              "</button>"
            : ""),
      "  </div>",
      "</section>",
    ].join("");
  }

  function renderStepTwo(context, isLocked) {
    var state = context.state;
    return [
      '<section class="njv-form-step ' + (state.step === 2 ? "is-active" : "") + '">',
      "  <h3>Step 2 · Business details</h3>",
      '  <div class="njv-form-grid">',
      renderInputField("Full name", "fullName", state.form.fullName, { autocomplete: "name", disabled: isLocked }),
      renderInputField("Email address", "email", state.form.email, {
        type: "email",
        autocomplete: "email",
        disabled: isLocked,
      }),
      renderInputField("Business name", "businessName", state.form.businessName, { disabled: isLocked }),
      renderInputField("GSTIN", "gstin", state.form.gstin, { placeholder: "15-character GSTIN", disabled: isLocked }),
      renderInputField("Drug license number", "drugLicenseNumber", state.form.drugLicenseNumber, {
        disabled: isLocked,
      }),
      renderInputField("Service area", "serviceArea", state.form.serviceArea, { disabled: isLocked }),
      renderTextArea("Business address", "businessAddress", state.form.businessAddress, { disabled: isLocked, span: true }),
      renderInputField("City", "city", state.form.city, { disabled: isLocked }),
      renderInputField("State", "state", state.form.state, { disabled: isLocked }),
      renderInputField("Pincode", "pincode", state.form.pincode, {
        placeholder: "6-digit pincode",
        inputmode: "numeric",
        disabled: isLocked,
      }),
      "  </div>",
      '  <div class="njv-form-actions">',
      '    <button type="button" class="njv-btn njv-btn-secondary" data-action="go-prev">Back</button>',
      isLocked
        ? '    <button type="button" class="njv-btn njv-btn-primary" data-action="go-next">View uploaded documents</button>'
        : '    <button type="button" class="njv-btn njv-btn-primary" data-action="go-next">Continue to documents</button>',
      "  </div>",
      "</section>",
    ].join("");
  }

  function renderStepThree(context, isLocked) {
    var state = context.state;
    return [
      '<section class="njv-form-step ' + (state.step === 3 ? "is-active" : "") + '">',
      "  <h3>Step 3 · Upload mandatory documents</h3>",
      '  <div class="njv-upload-grid">',
      renderUploadCard("GST certificate", "gst_certificate", state.form.documents.gst_certificate, isLocked),
      renderUploadCard("Drug license", "drug_license", state.form.documents.drug_license, isLocked),
      "  </div>",
      '  <div class="njv-inline-note">Accepted formats: JPG, PNG, WEBP, or PDF. Keep each file under 6 MB for faster submission.</div>',
      '  <div class="njv-form-actions">',
      '    <button type="button" class="njv-btn njv-btn-secondary" data-action="go-prev">Back</button>',
      '    <button type="button" class="njv-btn njv-btn-primary" data-action="go-next">Review application</button>',
      "  </div>",
      "</section>",
    ].join("");
  }

  function renderStepFour(context, isLocked) {
    var state = context.state;
    var termsUrl = context.config.termsUrl ? String(context.config.termsUrl) : "";
    var privacyUrl = context.config.privacyUrl ? String(context.config.privacyUrl) : "";
    var submitDisabled =
      state.loading === "submit" || !state.form.otpVerified || (isLocked && state.currentApplication && state.currentApplication.status !== "needs_resubmission");

    return [
      '<section class="njv-form-step ' + (state.step === 4 ? "is-active" : "") + '">',
      "  <h3>Step 4 · Review and submit</h3>",
      '  <div class="njv-review-grid">',
      renderReviewCard("Primary contact", [
        ["Full name", state.form.fullName],
        ["Mobile", state.mobile || state.form.mobile],
        ["Email", state.form.email],
      ]),
      renderReviewCard("Business", [
        ["Business name", state.form.businessName],
        ["GSTIN", state.form.gstin],
        ["Drug license", state.form.drugLicenseNumber],
        ["Service area", state.form.serviceArea],
      ]),
      renderReviewCard("Address", [
        ["Business address", state.form.businessAddress],
        ["City", state.form.city],
        ["State", state.form.state],
        ["Pincode", state.form.pincode],
      ]),
      renderReviewCard("Documents", [
        ["GST certificate", state.form.documents.gst_certificate ? state.form.documents.gst_certificate.fileName : "Not uploaded"],
        ["Drug license", state.form.documents.drug_license ? state.form.documents.drug_license.fileName : "Not uploaded"],
      ]),
      "  </div>",
      '  <div class="njv-inline-note">By submitting, you confirm the business details and uploaded documents are correct. Navajiva will verify GST, drug license, and contact information before approval.' +
        (termsUrl || privacyUrl
          ? " " +
            [termsUrl ? '<a href="' + escapeAttribute(termsUrl) + '" target="_blank" rel="noopener">Terms</a>' : "", privacyUrl ? '<a href="' + escapeAttribute(privacyUrl) + '" target="_blank" rel="noopener">Privacy</a>' : ""]
              .filter(Boolean)
              .join(" · ")
          : "") +
        "</div>",
      '  <div class="njv-form-actions">',
      '    <button type="button" class="njv-btn njv-btn-secondary" data-action="go-prev">Back</button>',
      submitDisabled
        ? isLocked
          ? '    <span class="njv-helper">This application is already in progress. The Navajiva team will continue the review and contact you if an update is needed.</span>'
          : '    <button type="button" class="njv-btn njv-btn-primary" disabled>Submitting...</button>'
        : '    <button type="button" class="njv-btn njv-btn-primary" data-action="submit-application">' +
          (state.currentApplication ? "Update application" : "Submit application") +
          "</button>",
      "  </div>",
      "</section>",
    ].join("");
  }

  function renderInputField(label, key, value, options) {
    options = options || {};
    return (
      '<div class="njv-field ' +
      (options.span ? "is-span-2" : "") +
      '">' +
      '<label for="njv-field-' +
      key +
      '">' +
      escapeHtml(label) +
      "</label>" +
      '<input id="njv-field-' +
      key +
      '" name="' +
      key +
      '" type="' +
      escapeAttribute(options.type || "text") +
      '" value="' +
      escapeAttribute(value || "") +
      '" ' +
      (options.placeholder ? 'placeholder="' + escapeAttribute(options.placeholder) + '" ' : "") +
      (options.inputmode ? 'inputmode="' + escapeAttribute(options.inputmode) + '" ' : "") +
      (options.autocomplete ? 'autocomplete="' + escapeAttribute(options.autocomplete) + '" ' : "") +
      (options.disabled ? "disabled " : "") +
      "/>" +
      "</div>"
    );
  }

  function renderTextArea(label, key, value, options) {
    options = options || {};
    return (
      '<div class="njv-field ' +
      (options.span ? "is-span-2" : "") +
      '">' +
      '<label for="njv-field-' +
      key +
      '">' +
      escapeHtml(label) +
      "</label>" +
      '<textarea id="njv-field-' +
      key +
      '" name="' +
      key +
      '" ' +
      (options.disabled ? "disabled " : "") +
      ">" +
      escapeHtml(value || "") +
      "</textarea>" +
      "</div>"
    );
  }

  function renderUploadCard(title, type, document, isLocked) {
    return [
      '<div class="njv-upload-card">',
      "  <h4>" + escapeHtml(title) + "</h4>",
      '  <p>Upload a clear image or PDF. These documents are used by the Navajiva team to review your distributor application.</p>',
      document
        ? '  <div class="njv-file-chip"><span>' +
          escapeHtml(document.fileName || "Uploaded") +
          "</span>" +
          (document.url ? '<a href="' + escapeAttribute(document.url) + '" target="_blank" rel="noopener">View</a>' : "<span>Ready</span>") +
          "</div>"
        : "",
      isLocked
        ? '  <div class="njv-helper">Document changes are locked while this application is under review.</div>'
        : '  <div class="njv-upload-actions"><label class="njv-btn njv-btn-secondary" for="njv-upload-' +
          type +
          '">Choose file</label><input class="njv-hidden-input" id="njv-upload-' +
          type +
          '" type="file" accept=".jpg,.jpeg,.png,.webp,.pdf" data-doc-type="' +
          type +
          '"></div>',
      "</div>",
    ].join("");
  }

  function renderReviewCard(title, entries) {
    return [
      '<div class="njv-review-card">',
      "  <h4>" + escapeHtml(title) + "</h4>",
      entries
        .map(function (entry) {
          return (
            '<div class="njv-review-item"><span>' +
            escapeHtml(entry[0]) +
            "</span><strong>" +
            escapeHtml(entry[1] || "Not provided") +
            "</strong></div>"
          );
        })
        .join(""),
      "</div>",
    ].join("");
  }

  function hasLockedStatus(application) {
    return Boolean(application && LOCKED_STATUSES.indexOf(application.status) !== -1);
  }

  function bindDynamicActions(context) {
    context.mountNode.querySelectorAll("input[name], textarea[name]").forEach(function (field) {
      field.addEventListener("input", function (event) {
        var target = event.currentTarget;
        var key = target.name;
        var nextValue = key === "gstin" || key === "drugLicenseNumber" ? target.value.toUpperCase() : target.value;
        if (key === "mobile") {
          var normalizedMobile = nextValue.replace(/\D/g, "").slice(0, 10);
          if (!context.state.form.otpVerified && normalizedMobile !== context.state.mobile) {
            context.state.otpSessionId = "";
            context.state.otp = "";
            context.state.error = "";
            context.state.message = "";
          }
          context.state.mobile = normalizedMobile;
          context.state.form.mobile = context.state.mobile;
          target.value = context.state.mobile;
          return;
        }

        if (key === "otp") {
          context.state.otp = nextValue.replace(/\D/g, "").slice(0, 6);
          target.value = context.state.otp;
          return;
        }

        context.state.form[key] = nextValue;
      });
    });

    context.mountNode.querySelectorAll("input[data-doc-type]").forEach(function (input) {
      input.addEventListener("change", function (event) {
        handleDocumentChange(context, event.currentTarget);
      });
    });

    context.mountNode.querySelectorAll("[data-action]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        var action = button.getAttribute("data-action");

        if (action === "request-otp") {
          requestOtp(context);
          return;
        }
        if (action === "verify-otp") {
          verifyOtp(context);
          return;
        }
        if (action === "go-next") {
          nextStep(context);
          return;
        }
        if (action === "go-prev") {
          previousStep(context);
          return;
        }
        if (action === "submit-application") {
          submitApplication(context);
          return;
        }
        if (action === "reset-session") {
          resetSession(context);
        }
      });
    });
  }

  async function handleDocumentChange(context, input) {
    var file = input.files && input.files[0];
    if (!file) {
      return;
    }

    if (!isSupportedDocument(file)) {
      context.state.error = "Only JPG, PNG, WEBP, and PDF files are supported.";
      render(context);
      return;
    }

    if (file.size > MAX_UPLOAD_BYTES) {
      context.state.error = "Please keep each uploaded file under 6 MB.";
      render(context);
      return;
    }

    var docType = input.getAttribute("data-doc-type");
    try {
      context.state.error = "";
      var dataUrl = await fileToDataUrl(file);
      context.state.form.documents[docType] = {
        id: "web-doc-" + Date.now() + "-" + docType,
        type: docType,
        fileName: file.name,
        url: dataUrl,
        uploadedAt: new Date().toISOString(),
      };
      render(context);
    } catch (error) {
      context.state.error = "Unable to read the selected file.";
      render(context);
    }
  }

  function isSupportedDocument(file) {
    var type = file.type || "";
    return type === "application/pdf" || type.indexOf("image/") === 0 || /\.(pdf|png|jpe?g|webp)$/i.test(file.name);
  }

  function fileToDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        resolve(String(reader.result || ""));
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async function requestOtp(context) {
    var mobileDigits = (context.state.mobile || "").replace(/\D/g, "");
    if (mobileDigits.length !== 10) {
      context.state.error = "Please enter a valid 10-digit mobile number before requesting OTP.";
      render(context);
      return;
    }

    try {
      context.state.loading = "requestOtp";
      context.state.error = "";
      context.state.message = "";
      render(context);

      var result = await apiRequest(context.config.apiBaseUrl, "/auth/request-otp", {
        method: "POST",
        body: { mobile: mobileDigits },
      });
      context.state.mobile = mobileDigits;
      context.state.form.mobile = mobileDigits;
      context.state.otpSessionId = result.otpSessionId;
      context.state.message = "OTP sent. Enter the code to continue.";
      trackEvent("otp_requested", context.state.tracking);
    } catch (error) {
      context.state.error = getErrorMessage(error, "Unable to request OTP right now.");
    } finally {
      context.state.loading = "";
      render(context);
    }
  }

  async function verifyOtp(context) {
    if (!context.state.otpSessionId) {
      context.state.error = "Request OTP first.";
      render(context);
      return;
    }

    if ((context.state.otp || "").trim().length < 4) {
      context.state.error = "Enter the OTP sent to your mobile number.";
      render(context);
      return;
    }

    try {
      context.state.loading = "verifyOtp";
      context.state.error = "";
      context.state.message = "";
      render(context);

      var verification = await apiRequest(context.config.apiBaseUrl, "/auth/verify-otp", {
        method: "POST",
        body: {
          otpSessionId: context.state.otpSessionId,
          otp: context.state.otp.trim(),
        },
      });

      context.state.token = verification.token;
      context.state.form.otpVerified = true;
      context.state.form.mobile = context.state.mobile;

      var currentApplication = await apiRequest(context.config.apiBaseUrl, "/applications/me", {
        method: "GET",
        token: context.state.token,
      });

      if (currentApplication) {
        context.state.currentApplication = currentApplication;
        hydrateFormFromApplication(context, currentApplication);
        context.state.message = buildStatusMessage(currentApplication.status);
        context.state.step = resolveStepForApplication(currentApplication);
      } else {
        context.state.currentApplication = null;
        context.state.message = "Mobile verified. Continue with business details.";
        context.state.step = 2;
      }

      persistSession(context);
      trackEvent("otp_verified", context.state.tracking);
    } catch (error) {
      context.state.error = getErrorMessage(error, "OTP verification failed.");
    } finally {
      context.state.loading = "";
      render(context);
    }
  }

  function nextStep(context) {
    if (context.state.step === 1) {
      if (!context.state.form.otpVerified || !context.state.token) {
        context.state.error = "Verify the mobile number first.";
        render(context);
        return;
      }
    }

    if (context.state.step === 2 && !validateBusinessStep(context)) {
      render(context);
      return;
    }

    if (context.state.step === 3 && !validateDocumentStep(context)) {
      render(context);
      return;
    }

    context.state.error = "";
    context.state.step = Math.min(TOTAL_STEPS, context.state.step + 1);
    render(context);
  }

  function previousStep(context) {
    context.state.error = "";
    context.state.step = Math.max(1, context.state.step - 1);
    render(context);
  }

  function validateBusinessStep(context) {
    var form = context.state.form;
    var requiredFields = [
      ["fullName", "full name"],
      ["email", "email address"],
      ["businessName", "business name"],
      ["gstin", "GSTIN"],
      ["drugLicenseNumber", "drug license number"],
      ["businessAddress", "business address"],
      ["city", "city"],
      ["state", "state"],
      ["pincode", "pincode"],
      ["serviceArea", "service area"],
    ];

    for (var i = 0; i < requiredFields.length; i += 1) {
      var field = requiredFields[i];
      if (!String(form[field[0]] || "").trim()) {
        context.state.error = "Please enter " + field[1] + ".";
        return false;
      }
    }

    if (!/^\S+@\S+\.\S+$/.test(form.email)) {
      context.state.error = "Please enter a valid email address.";
      return false;
    }

    if (String(form.gstin).trim().length !== 15) {
      context.state.error = "GSTIN should be 15 characters.";
      return false;
    }

    if (!/^\d{6}$/.test(String(form.pincode).trim())) {
      context.state.error = "Pincode should be exactly 6 digits.";
      return false;
    }

    return true;
  }

  function validateDocumentStep(context) {
    if (!context.state.form.documents.gst_certificate) {
      context.state.error = "Please upload the GST certificate.";
      return false;
    }

    if (!context.state.form.documents.drug_license) {
      context.state.error = "Please upload the drug license.";
      return false;
    }

    return true;
  }

  async function submitApplication(context) {
    if (!validateBusinessStep(context) || !validateDocumentStep(context)) {
      render(context);
      return;
    }

    if (!context.state.token || !context.state.form.otpVerified) {
      context.state.error = "Verify the mobile number first.";
      render(context);
      return;
    }

    try {
      context.state.loading = "submit";
      context.state.error = "";
      context.state.message = "";
      render(context);

      var submitted = await apiRequest(context.config.apiBaseUrl, "/applications/me", {
        method: "POST",
        token: context.state.token,
        body: buildPayload(context),
      });

      context.state.currentApplication = submitted;
      hydrateFormFromApplication(context, submitted);
      context.state.message = context.config.successBody || "Your distributor application has been submitted for Navajiva review.";
      context.state.step = 4;
      persistSession(context);
      trackEvent("application_submitted", context.state.tracking);
    } catch (error) {
      context.state.error = getErrorMessage(error, "Unable to submit the application.");
    } finally {
      context.state.loading = "";
      render(context);
    }
  }

  function buildPayload(context) {
    var form = context.state.form;
    return {
      otpVerified: true,
      source: "website_landing",
      tracking: context.state.tracking,
      fullName: form.fullName.trim(),
      mobile: context.state.mobile.trim(),
      email: form.email.trim(),
      businessName: form.businessName.trim(),
      gstin: form.gstin.trim().toUpperCase(),
      drugLicenseNumber: form.drugLicenseNumber.trim().toUpperCase(),
      businessAddress: form.businessAddress.trim(),
      city: form.city.trim(),
      state: form.state.trim(),
      pincode: form.pincode.trim(),
      serviceArea: form.serviceArea.trim(),
      documents: [form.documents.gst_certificate, form.documents.drug_license].filter(Boolean),
    };
  }

  function resetSession(context) {
    context.state = createState(context.config);
    clearSession();
    render(context);
  }

  async function apiRequest(apiBaseUrl, path, options) {
    options = options || {};
    var base = String(apiBaseUrl || "").replace(/\/$/, "");
    var response = await fetch(base + path, {
      method: options.method || "GET",
      headers: {
        "Content-Type": "application/json",
        ...(options.token ? { Authorization: "Bearer " + options.token } : {}),
      },
      body: options.body ? JSON.stringify(options.body) : undefined,
      credentials: "omit",
    });

    if (!response.ok) {
      throw new Error(await parseApiError(response));
    }

    var text = await response.text();
    return text ? JSON.parse(text) : null;
  }

  async function parseApiError(response) {
    var text = await response.text();
    if (!text) {
      return "Request failed with status " + response.status;
    }

    try {
      var payload = JSON.parse(text);
      if (Array.isArray(payload.message)) {
        return payload.message.join(", ");
      }
      return payload.message || payload.error || text;
    } catch (error) {
      return text;
    }
  }

  function formatStatus(status) {
    var labels = {
      draft: "Draft",
      submitted: "Submitted",
      under_review: "Under review",
      call_pending: "Call pending",
      agreement_pending: "Agreement pending",
      agreement_signed: "Agreement received",
      approved: "Approved",
      rejected: "Rejected",
      needs_resubmission: "Needs resubmission",
    };
    return labels[status] || "Not started";
  }

  function buildStatusMessage(status) {
    var messages = {
      draft: "Your application is saved as draft. Complete the remaining details and submit it for review.",
      submitted: "Your application has been received. The Navajiva team will start document verification shortly.",
      under_review: "Your business details and uploaded documents are under review by the Navajiva team.",
      call_pending: "Your application is progressing. Expect a verification call from the Navajiva team.",
      agreement_pending: "Your documents are approved. The team will share the distributor agreement as the next step.",
      agreement_signed: "Your signed agreement is under final verification before approval.",
      approved: "This mobile number already belongs to an approved distributor account.",
      rejected: "This application was rejected. Please contact the Navajiva team for the next steps.",
      needs_resubmission: "Please update the requested details or documents and resubmit your application.",
    };
    return messages[status] || "";
  }

  function getErrorMessage(error, fallback) {
    if (error && typeof error.message === "string") {
      return error.message;
    }
    return fallback;
  }

  function trackEvent(name, payload) {
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: "navajiva_distributor_" + name,
        distributorTracking: payload,
      });
    }

    if (typeof window.fbq === "function") {
      window.fbq("trackCustom", "NavajivaDistributor" + camelize(name), payload);
    }
  }

  function camelize(value) {
    return String(value || "")
      .split("_")
      .map(function (segment) {
        return segment.charAt(0).toUpperCase() + segment.slice(1);
      })
      .join("");
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
